import { Collaboration } from "@back4app2/sdk";
import { ReactComponent as TrashOutlineSVG } from "../../assets/images/trash-outline-icon.svg";
import { ReactComponent as EditPenSVG } from "../../assets/images/edit-pen-icon.svg";

export interface CollaboratorItemProps {
  collaborator: Collaboration;
  onRemove: (collaborator: Collaboration) => void;
  onEdit: (collaborator: Collaboration) => void;
  isAppOwner: boolean;
  currentUserEmail: string;
}

export const CollaboratorItem = ({
  collaborator,
  onRemove,
  onEdit,
  isAppOwner,
  currentUserEmail,
}: CollaboratorItemProps) => {
  return (
    <div className='flex items-center justify-between p-3 bg-dark-blue rounded-md'>
      <div className='flex-1 flex items-center gap-2'>
        {collaborator.isPending ? (
          <div className='w-3 h-3 rounded-full bg-system-yellow'></div>
        ) : (
          <div className='w-3 h-3 rounded-full bg-cta-green'></div>
        )}
        <div className='text-sm'>{collaborator.email}</div>
      </div>
      <div className='flex items-center gap-3'>
        {isAppOwner ? (
          <EditPenSVG
            className='w-4 h-4 cursor-pointer text-old-blue'
            onClick={() => onEdit(collaborator)}
          />
        ) : null}
        {isAppOwner || currentUserEmail === collaborator.email ? (
          <TrashOutlineSVG
            className='w-4 h-4 cursor-pointer text-system-red'
            onClick={() => onRemove(collaborator)}
          />
        ) : null}
      </div>
    </div>
  );
};

export interface CollaboratorsListProps {
  collaborators: Collaboration[];
  onRemove: (collaborator: Collaboration) => void;
  onEdit: (collaborator: Collaboration) => void;
  isAppOwner: boolean;
  currentUserEmail: string;
}

export const CollaboratorsList = ({
  collaborators,
  onRemove,
  onEdit,
  isAppOwner,
  currentUserEmail,
}: CollaboratorsListProps) => {
  if (collaborators.length === 0) {
    return null;
  }

  return (
    <div className='mt-6'>
      {isAppOwner && <div className='text-sm font-semibold mb-3'>Current Collaborators</div>}
      <div className='space-y-2'>
        {collaborators.map((collaborator) => (
          <CollaboratorItem
            key={collaborator.id}
            collaborator={collaborator}
            onRemove={onRemove}
            onEdit={onEdit}
            isAppOwner={isAppOwner}
            currentUserEmail={currentUserEmail}
          />
        ))}
      </div>
    </div>
  );
};

export default CollaboratorsList;
